module.exports = __webpack_public_path__ + "static/people_working-0751a21e203045d2c33e57dc19b15fea.svg";